/**
 * Transfer type constants for wallet transactions
 * Used across wallet-app and admin-app for consistent display labels
 */

/**
 * Allowed currency codes for multi-currency deposits wallets.
 * Used when filtering deposits wallets for the currency switcher (EUR, USD, GBP only).
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const DEPOSITS_WALLET_ALLOWED_CURRENCY_CODES: string[] = ['EUR', 'USD', 'GBP'];

/**
 * Check if a currency code is allowed for deposits wallets.
 */
export const isDepositsWalletAllowedCurrency = (code: string): boolean =>
  DEPOSITS_WALLET_ALLOWED_CURRENCY_CODES.includes(code);

/**
 * Map of transfer_type kebab-case values to user-friendly display labels
 * Includes both old and new values for backward/forward compatibility during BE transition
 *
 * Value changes (old → new):
 * - bank-withdraw → bank-withdrawal
 * - internal-refund → refund
 * - balance-reward → rewards
 * - card-top-up → wallet-top-up
 * - bank-top-up → bank-transfer
 */
export const TRANSFER_TYPE_LABELS: Record<string, string> = {
  payroll: 'Payroll',
  'supplemental-pay': 'Supplemental pay',
  'severance-accrual': 'Severance accrual',
  expense: 'Expense',
  invoice: 'Invoice',
  // bank-withdraw (old) and bank-withdrawal (new)
  'bank-withdraw': 'Bank withdrawal',
  'bank-withdrawal': 'Bank withdrawal',
  'team-transfer': 'Team transfer',
  'currency-conversion': 'Currency conversion',
  payoneer: 'Payoneer',
  // internal-refund (old) → display as 'Refund', refund (new)
  'internal-refund': 'Refund',
  refund: 'Refund',
  // eps-card-top-up → display as 'Card top-up'
  'eps-card-top-up': 'Card top-up',
  // balance-reward (old) → display as 'Rewards', rewards (new)
  'balance-reward': 'Rewards',
  rewards: 'Rewards',
  // card-top-up (old) → display as 'Wallet top-up', wallet-top-up (new)
  'card-top-up': 'Wallet top-up',
  'wallet-top-up': 'Wallet top-up',
  // bank-top-up (old) → display as 'Bank transfer', bank-transfer (new)
  'bank-top-up': 'Bank transfer',
  'bank-transfer': 'Bank transfer',
  // contractor-payment-bank-withdrawal → display as 'Contractor payment bank withdraw'
  'contractor-payment-bank-withdraw': 'Contractor payment bank withdraw',
  'contractor-payment': 'Contractor payment',
  subscription: 'Subscription',
  other: 'Other',
  'fee-reimbursement': 'Fee reimbursement',
  'gig-payment': 'Gig payment',
  'gig-payment-fee': 'Gig payment fee',
  'salary-bank-withdraw': 'Transfer to bank',
};

/**
 * Helper to format kebab-case to Title Case (fallback for unknown transfer types)
 */
export const formatTransferTypeLabel = (transferType: string): string => {
  return transferType
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Get the display label for a transfer type
 * Falls back to formatting the transfer type if not found in the map
 */
export const getTransferTypeLabel = (transferType: string): string => {
  const lowerTransferType = transferType.toLowerCase();
  return TRANSFER_TYPE_LABELS[lowerTransferType] || formatTransferTypeLabel(transferType);
};
